import axios from "axios";
import Config from "../config"
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();
export default class UserService {
  constructor() {
    this.loginStore = null;
  }

  store() {
    if(!this.loginStore) { this.loginStore = useLoginStore(); };
    return this.loginStore;
  }
  
  fetchDeleteUser(id) {

    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{},
      }
    };
    
    return axios
    
      .delete(
        Config.url("delete_user_admin") + "/" + id,
        options
      )
      .then(res => res.data);
  }

  fetchUsers(limit = 10, offset = 0, filters = [], sortObject, count = true, count_attr = "registration_time") {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{},
      }
    }
    let bodyTosend = {
      // "tenant": this.store().getTenant,
      // "country": "global",
      "limit": limit,
      "offset": offset,
      // "count": count,
      // "count_attr": count_attr,
    }
    // if (filters.length > 0) {
      bodyTosend.filter_attributes = filters;
    // }
    if (sortObject.order_attr !== "") {
      bodyTosend.order_attr = sortObject.order_attr;
      bodyTosend.asc_or_desc = sortObject.asc_or_desc;
    }
    return axios
      .post(
        Config.url("user"),
        bodyTosend,
        options
      )
      .then(res => res.data);
  }
  fetchUser(id = null) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };
    return axios
      .post(
        Config.url("user") + "/" + id,
        {},
        options
      )
      .then(res => res.data);
  }
  fetchDealers() {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };
    return axios
      .get(
        Config.url("dealers"),
        options
      )
      .then(res => res.data);
  }
  approveDealer(email) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };
    return axios
      .post(
        Config.url("approve_dealer"),
        {
          "email": email
        },
        options
      )
      .then(res => res.data);
  }
}
